<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog" v-closable="{ exclude: [], handler: 'onClickOutside' }" @keydown.esc="$emit('closeDialog')" persistent max-width="400" @keydown.left="loadPrevious" @keydown.right="loadNext">
      <template v-slot:activator="{ on }" v-if="addBtn">
        <v-btn color="#0e9e98de" dark small absolute top right fab v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <transaction-card-default v-if="record.subject && !record.record_type" :record="record" @closeDialog="$emit('closeDialog')"></transaction-card-default>
      <transaction-card-transaction v-if="record.subject && record.record_type == 'internal_transaction'" :record="record" @closeDialog="$emit('closeDialog')"></transaction-card-transaction>
      <transaction-card-wire v-if="record && record.record_type == 'internal_wire'" :record="record" @closeDialog="$emit('closeDialog')"></transaction-card-wire>
    </v-dialog>
  </v-layout>
</template>

<script>
import CustomerScheduledBankTransactionDetailsCard from "./CustomerScheduledBankTransactionDetailsCard"
import CustomerInternalTransactionDetailsCard from "./CustomerInternalTransactionDetailsCard"
import CustomerInternalWireDetailsCard from "./CustomerInternalWireDetailsCard"

export default {
  name: 'CustomerScheduledBankTransactionDetailsDialog',
  props: {
    addBtn: {
      type: Boolean,
      default: true
    },
    record: {
      type: Object,
    },
    hasPrevious: {
      type: Boolean,
      default: false
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'transaction-card-default': CustomerScheduledBankTransactionDetailsCard,
    'transaction-card-transaction': CustomerInternalTransactionDetailsCard,
    'transaction-card-wire': CustomerInternalWireDetailsCard
  },
  data: (vm) => {
    return {
      captureKeyboard: false
    }
  },
  watch: {
    dialog (val) {
      if (val == false) {
        this.captureKeyboard = false
        // closed
      } else {
        this.captureKeyboard = true
        // opened
      }
    }
  },
  methods: {
    loadPrevious(e) {
      if (!this.captureKeyboard) return
      e.stopPropagation()
      this.$emit('loadPrevious')
    },
    loadNext(e) {
      if (!this.captureKeyboard) return
      e.stopPropagation()
      this.$emit('loadNext')
    },
    onClickOutside() {
      if (!this.isMobile) {
        this.$emit('closeDialog')
      }
    },
  },
  computed: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/CustomerScheduledBankTransactionDetailsDialog.vue